import api from '@/services/api';
import { vehiclesPath } from '.';
import type {
    VehicleSearchFilters,
    FilteredOptionsResponse,
    VehicleDerivativeSearchResponse,
} from '../types/manualsearch.types';

export interface FilteredOptionsRequestOptions {
    /**
     * When true, ask the backend to include a bounded matching_vehicles list once
     * make+model are selected (relaxed path), instead of requiring all six criteria.
     * The quote journey must NOT set this — its six-field contract is unchanged.
     */
    includeDerivatives?: boolean;
}

export const getFilteredOptions = async (
    filters: VehicleSearchFilters,
    options: FilteredOptionsRequestOptions = {}
): Promise<FilteredOptionsResponse> => {
    const params = new URLSearchParams();
    Object.entries(filters).forEach(([key, value]) => {
        if (value !== undefined && value !== null) {
            params.append(key, value.toString());
        }
    });
    if (options.includeDerivatives) {
        params.append('include_derivatives', '1');
    }

    const response = await api.get(`${vehiclesPath}/filtered-options?${params}`);
    return response.data.data;
};

export const manualSearchVehicles = async (
    filters: VehicleSearchFilters
): Promise<VehicleDerivativeSearchResponse> => {
    const response = await api.post(`${vehiclesPath}/manual-search`, filters);
    return response.data.data;
};
